<div class="header-container">
  <mat-toolbar color="primary">
    <div>
      <div class="logo">
        <img
          src="https://inforida.ams3.cdn.digitaloceanspaces.com/assets/new-inforida-logo%20(2).png"
          routerLink="/home"
          alt="Inforida"
          style="width: 140px; cursor: pointer"
        />
      </div>
    </div>

    <div class="links-mobile" *ngIf="isMobile">
      <div class="menu-wrap" (click)="toggleMenu()">
        <img src="../assets/images/menuLogo.png" alt="menu-logo" />
      </div>
      <div class="side-menu" [class.open]="menuOpen">
        <div class="close-icon" (click)="toggleMenu($event)">&#10005;</div>
        <div class="display display-menu">
          <div routerLink="/home" class="nav-button" (click)="closeMenu()">
            Home
          </div>
          <div routerLink="/about-us" class="nav-button" (click)="closeMenu()">
            About us
          </div>
          <div
            routerLink="/why-inforida"
            class="nav-button"
            (click)="closeMenu()"
          >
            Why Inforida?
          </div>
          <div class="dropdown">
            <div class="nav-button wrap" (click)="toggleDropdown(0)">
              <div class="nav-button">Tools</div>
              <img src="../assets/images/downarrow.png" />
            </div>
            <div *ngIf="openDropdownIndex === 0" class="drop-menu">
              <div
                class="container"
                (click)="closeDropdown(); closeMenu()"
                routerLink="/products/QuickEnroll-AI"
              >
                <img
                  src="../../../assets/images/quick-enroll-ai.png"
                  class="icon"
                />
                <!-- <mat-icon class="icon">smart_toy</mat-icon> -->
                <div class="wrapper">
                  <h2>QuickEnroll AI</h2>
                  <p>Build Your Digital Presence</p>
                </div>
              </div>
              <div
                class="container"
                (click)="closeDropdown(); closeMenu()"
                routerLink="/products/goood-morning"
              >
                <img
                  src="../../../assets/images/goood-morning.png"
                  class="icon"
                />
                <!-- <mat-icon class="icon">face</mat-icon> -->
                <div class="wrapper">
                  <h2>Good Morning!</h2>
                  <p>AI-Powered Biometric Attendance</p>
                </div>
                <!-- <p>About Attendance</p> -->
              </div>
              <div
                class="container"
                (click)="closeDropdown(); closeMenu()"
                routerLink="/products/inforida-orbit"
              >
                <img src="../../../assets/images/orbit.png" class="icon" />
                <!-- <mat-icon class="icon">apps</mat-icon> -->
                <div class="wrapper">
                  <h2>Nucleus</h2>
                  <p>All in One ERP for Schools</p>
                </div>
              </div>
            </div>
          </div>
          <div class="dropdown">
            <div class="nav-button wrap" (click)="toggleDropdown(1)">
              <div class="nav-button">Ecosystem</div>
              <img src="../assets/images/downarrow.png" />
            </div>
            <div *ngIf="openDropdownIndex === 1" class="drop-menu">
              <div
                (click)="closeDropdown(); closeMenu()"
                routerLink="/admin-staff"
                class="container"
              >
                <img src="../assets/images/briefcase.png" />
                <div class="wrapper">
                  <h2>For Admin</h2>
                  <p>A Platform for Admin</p>
                </div>
              </div>
              <div
                (click)="closeDropdown(); closeMenu()"
                routerLink="/academic-staff"
                class="container"
              >
                <img src="../assets/images/briefcase.png" />
                <div class="wrapper">
                  <h2>For Academics Staff</h2>
                  <p>A Platform for Academics</p>
                </div>
              </div>
              <div
                (click)="closeDropdown(); closeMenu()"
                routerLink="/parents"
                class="container"
              >
                <img src="../assets/images/briefcase.png" />
                <div class="wrapper">
                  <h2>For Parents</h2>
                  <p>A Platform for Parents</p>
                </div>
              </div>
            </div>
          </div>
          <!-- <a mat-button routerLink="/blogs" class="nav-button" [ngClass]="{'selected-web': currentUrlState === '/blogs'}">
            Blog
          </a> -->
          <div
            routerLink="/contact-us"
            class="nav-button"
            (click)="closeMenu()"
          >
            Contact Us
          </div>
        </div>
        <div
          class="display"
          style="justify-content: end !important"
          (click)="closeMenu()"
        >
          <a
            mat-raised-button
            href="https://app.inforida.com"
            class="button-login"
          >
            Sign in
          </a>
        </div>
      </div>
    </div>

    <div class="display desktop-view" *ngIf="!isMobile">
      <div routerLink="/home" class="nav-button">Home</div>
      <div routerLink="/about-us" class="nav-button">About us</div>
      <div class="dropdown">
        <div class="nav-button wrap" (click)="toggleDropdown(0)">
          <div class="nav-button">Products</div>
          <img src="../assets/images/downarrow.png" />
        </div>
        <div *ngIf="openDropdownIndex === 0" class="drop-menu">
          <div
            (click)="closeDropdown()"
            routerLink="/products/QuickEnroll-AI"
            class="container"
          >
            <img
              src="../../../assets/images/quick-enroll-ai.png"
              class="icon"
            />
            <!-- <mat-icon class="icon">smart_toy</mat-icon> -->
            <div class="wrapper">
              <h2>QuickEnroll AI</h2>
              <p>Simplifying Admissions, Build Your Digital Presence</p>
            </div>
          </div>
          <div
            (click)="closeDropdown()"
            class="container"
            routerLink="/products/goood-morning"
          >
            <img src="../../../assets/images/goood-morning.png" class="icon" />
            <!-- <mat-icon class="icon">face</mat-icon> -->
            <div class="wrapper">
              <h2>Good Morning!</h2>
              <p>AI-Powered Biometric Attendance for Schools</p>
            </div>
          </div>
          <div
            (click)="closeDropdown()"
            class="container"
            routerLink="products/inforida-orbit"
          >
            <img src="../../../assets/images/orbit.png" class="icon" />
            <!-- <mat-icon class="icon">apps</mat-icon> -->
            <div class="wrapper">
              <h2>Nucleus</h2>
              <p>All in One ERP for smarter School management</p>
            </div>
          </div>
        </div>
      </div>
      <div class="dropdown">
        <div class="nav-button wrap" (click)="toggleDropdown(1)">
          <div class="nav-button">Ecosystem</div>
          <img src="../assets/images/downarrow.png" />
        </div>
        <div *ngIf="openDropdownIndex === 1" class="drop-menu">
          <div
            (click)="closeDropdown()"
            routerLink="/admin-staff"
            class="container"
          >
            <img src="../assets/images/briefcase.png" />
            <div class="wrapper">
              <h2>For Admin</h2>
              <p>A Platform for Admin</p>
            </div>
          </div>
          <div
            (click)="closeDropdown()"
            routerLink="/academic-staff"
            class="container"
          >
            <img src="../assets/images/briefcase.png" />
            <div class="wrapper">
              <h2>For Academics Staff</h2>
              <p>A Platform for Academics</p>
            </div>
          </div>
          <div
            (click)="closeDropdown()"
            routerLink="/parents"
            class="container"
          >
            <img src="../assets/images/briefcase.png" />
            <div class="wrapper">
              <h2>For Parents</h2>
              <p>A Platform for Parents</p>
            </div>
          </div>
        </div>
      </div>
      <!-- <a mat-button routerLink="/blogs" class="nav-button" [ngClass]="{'selected-web': currentUrlState === '/blogs'}">
        Blog
      </a> -->
      <div routerLink="/contact-us" class="nav-button">Contact Us</div>
    </div>
    <div
      class="display sign-in-btn"
      style="justify-content: end !important"
      *ngIf="!isMobile"
    >
      <a mat-raised-button href="https://app.inforida.com" class="button-login">
        Sign in
      </a>
    </div>
    <!-- <----------------------mobile view---------------------------------->
    <!-- <div class="fill-remaining-space">
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>menu</mat-icon>
      </button>
      <mat-menu #menu="matMenu" [overlapTrigger]="false">
        <button mat-menu-item class="mv-menu">
          <span routerLink="/home">Home</span>
        </button>
        <button mat-menu-item class="mv-menu">
          <span routerLink="/products">Products</span>
        </button>
        <button mat-menu-item class="mv-menu">
          <span routerLink="/about-us">About us</span>
        </button>
        <button mat-menu-item class="mv-menu">
          <span routerLink="/contact-us">Contact Us</span>
        </button>
        <a href="https://app.inforida.com " class="link">
          <button mat-menu-item class="mv-menu">
            <span>Sign In</span>
          </button></a
        >
      </mat-menu>
    </div> -->
  </mat-toolbar>
</div>
